import { useState, useEffect } from "react";
import { getDetailsForTransfert } from "./Services/transfertService";

const TransfertDetailModal = ({ document, sourceType, panier, onClose, onSave }) => {

  const [lignes, setLignes] = useState([]);
  // 🔥 Charger les détails au montage

  const toggleV0 = (index) => {
    setLignes(prev =>
      prev.map((l, i) =>
        i === index
          ? { ...l, checked: !l.checked }
          : l
      )
    );
  };

  const toggle = (index) => {
    setLignes(prev =>
      prev.map((l, i) => {
        if (i !== index)
          return l;

        const checked = !l.checked;
        const remaining = Number(l.remainingQuantity) || 0;

        return {
          ...l,
          checked,
          quantite: checked ? remaining : 0
        };
      })
    );
  };

  const updateQte = (index, value) => {
    setLignes(prev =>
      prev.map((l, i) =>
        i === index
          ? { ...l, quantite: value }
          : l
      )
    );
  };
  // useEffect(() => {
  //   if (!document) return;

  //   const fetchDetails = async () => {
  //     try {
  //       // setLoading(true);
  //       const response = await getDetailsForTransfert(document.id);

  //       // Adapter la structure si nécessaire
  //       const data = response.data;
  //       setLignes(data.lignes)
  //       console.log(lignes);

  //     } catch (err) {
  //       // setError("Erreur lors du chargement");
  //     } finally {
  //       // setLoading(false);
  //     }
  //   };

  //   fetchDetails();
  // }, [document]);
  useEffect(() => {
    if (!document) return;

    const fetchDetails = async () => {
      debugger
      console.log("Type source : ", sourceType);
      const response = await getDetailsForTransfert(document.id, sourceType);
      const data = response.data;

      // chercher si document déjà dans panier
      const existingDoc = panier.find(
        p => p.sourceDocumentId === document.id
      );

      let lignesMapped = data.lignes.map(l => {
        if (!existingDoc) {
          return {
            ...l,
            checked: false,
            quantite: l.quantite
          };
        }

        const existingLigne = existingDoc.lignes.find(
          el => el.ligneId === l.id
        );

        if (existingLigne) {
          return {
            ...l,
            checked: true,
            quantite: existingLigne.quantite
          };
        }

        return {
          ...l,
          checked: false,
          quantite: l.quantite
        };
      });

      setLignes(lignesMapped);
    };

    fetchDetails();
  }, [document]);


  if (!document) return null;

  return (
    <div className="modal show d-block">

      <div className="modal-dialog modal-xl">
        <div className="modal-content">

          <div className="modal-header">
            <h5>Détail document</h5>
            <button className="close" onClick={onClose}>×</button>
          </div>

          <div className="modal-body">

            <table className="table">
              <thead>
                <tr>
                  <th></th>
                  <th>Code</th>
                  <th>Article</th>
                  <th>Stock</th>
                  <th>Quantité</th>
                  <th>Déjà transférée</th>
                  <th>Restante</th>
                  <th>À transférer</th>
                </tr>
              </thead>

              <tbody>
                {lignes.map((l, i) => (
                  <tr key={l.id}>

                    <td>
                      <input
                        type="checkbox"
                        checked={l.checked ?? false}
                        onChange={() => toggle(i)}
                        disabled={Number(l.remainingQuantity) <= 0}
                      />
                    </td>

                    <td>{l.code}</td>
                    <td>{l.articleName}</td>
                    <td>{l.stockQuantity}</td>
                    <td>{l.quantity}</td>
                    <td>{l.transferredQuantity}</td>
                    <td>{l.remainingQuantity}</td>

                    <td>
                      <input
                        type="number"
                        min={0}
                        max={Math.min(
                          l.remainingQuantity,
                          l.stockQuantity
                        )}
                        value={l.quantite ?? 0}
                        onChange={e => updateQte(i, e.target.value)}
                        disabled={!l.checked || Number(l.remainingQuantity) <= 0}
                      />
                    </td>

                  </tr>
                ))}
              </tbody>

            </table>

          </div>

          <div className="modal-footer">
            <button className="btn btn-success" onClick={() => {
              const selectedLignes = lignes
                .filter(l => l.checked)
                .map(l => ({
                  ligneId: l.id,
                  quantite: l.quantite
                  // quantite: l.quantiteTransfert ?? l.quantite
                }));

              onSave({
                sourceDocumentId: document.id,
                tierId: document.tierId,
                lignes: selectedLignes
              });

              onClose();
            }}>
              Sauvegarder
            </button>
          </div>

        </div>
      </div>

    </div>
  );
};

export default TransfertDetailModal;
